import React, { useContext, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AppContext from 'context/Context';
import classNames from 'classnames';
import NavbarTop from 'akasia-components/navbar/top/NavbarTop';
import NavbarVertical from 'akasia-components/navbar/vertical/NavbarVertical';
import Footer from 'akasia-components/footer/Footer';

import { onMessage, getToken, deleteToken } from "firebase/messaging";

import { messaging } from "../firebase/firebaseConfig";

import useToken from 'hooks/useToken';

import { toast, Flip } from 'react-toastify';
import ModalSeguimientoLead from '../akasia-components/leads/ModalSeguimientoLead';
import ReleaseNotesModal from '../akasia-components/ReleaseNotesModal';
import { useState } from 'react';



const MainLayout = () => {
    // const isChat = pathname.includes('chat');
    const { hash, pathname } = useLocation();
    const isKanban = pathname.includes('kanban');
    const { token, setToken } = useToken();
    const {
        config: { isFluid, navbarPosition }
    } = useContext(AppContext);



    const [isAllRead, setIsAllRead] = useState(0);
    const [isAllReadLiberados, setIsAllReadLiberados] = useState(0);
    const [showModalSeguimientoLead, setShowModalSeguimientoLead] = useState(false);
    const [idLead, setIdLead] = useState(0);
    const [notificaciones, setNotificaciones] = useState([]);
    const [notificacionesLiberados, setNotificacionesLiberados] = useState([]);
    const [lastNotf, setLastNotf] = useState(0);
    const [lastNotfLiberados, setLastNotfLiberados] = useState(0);
    const { showReleaseNotes, setShowReleaseNotes } = useToken();
    const [showReleaseModal, setShowReleaseModal] = useState(false);
    const [isDeudaOpen, setIsDeudaOpen] = useState(false);

    useEffect(() => {
        const handleDeudaOpen = () => setIsDeudaOpen(true);
        const handleDeudaClose = () => setIsDeudaOpen(false);

        window.addEventListener('OrdenesDeudaOpened', handleDeudaOpen);
        window.addEventListener('OrdenesDeudaClosed', handleDeudaClose);

        return () => {
            window.removeEventListener('OrdenesDeudaOpened', handleDeudaOpen);
            window.removeEventListener('OrdenesDeudaClosed', handleDeudaClose);
        };
    }, []);

    useEffect(() => {
        console.log("=== DEBUG MainLayout.js ===");
        console.log("showReleaseNotes value from useToken:", showReleaseNotes);
        
        // Damos tiempo a que los otros componentes (como el modal de deudas) carguen
        const timer = setTimeout(() => {
            if (showReleaseNotes === true || showReleaseNotes === "true") {
                console.log("Setting showReleaseModal to TRUE after delay");
                setShowReleaseModal(true);
            } else {
                console.log("Setting showReleaseModal to FALSE after delay");
                setShowReleaseModal(false);
            }
        }, 1500);

        return () => clearTimeout(timer);
    }, [showReleaseNotes]);

    const handleReleaseNotesDismissForever = () => {
        setShowReleaseNotes(false);
    };

    /**
     * Guarda el token en la BD
     * @param {any} token
     */
    const verificarSesion = async (tokenFirebase) => {

        var objDataSend = {};

        objDataSend.tokenFirebase = tokenFirebase;

        var jDataSend = JSON.stringify(objDataSend);

        const response = await fetch("/api/account/VerificarSesion/",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }, body: jDataSend
            }).catch((error) => {
                ;
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 3) {
                setToken(null);
                var a = await deleteToken(messaging);
                console.log(a);
                location.href = "";
            }

            if (data.iResponseType == 4) {
                // ========== CÓDIGO NUEVO AGREGADO ==========
                // Si quieres volver a la versión original, comenta desde aquí...

                // Guardar el token en la BD
                const saveResponse = await fetch("/api/account/GuardarToken/", {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ tokenFireBase: tokenFirebase })
                });

                if (saveResponse.ok) {
                    const saveData = await saveResponse.json();

                    if (saveData.iResponseType === 1) {
                        toast.success("Notificaciones activadas", {
                            position: "bottom-right",
                            autoClose: 3000,
                            theme: "colored"
                        });
                    }
                }

                // ...hasta aquí para revertir
                // ========== FIN CÓDIGO NUEVO ==========
            }


        }
        else {
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    }

    /**
     * recupera el token de firebase
     */
    /**
     * Solicita permisos de notificación si no están concedidos
     */
    const solicitarPermisosNotificacion = async () => {
        // Verificar si el navegador soporta notificaciones
        if (!('Notification' in window)) {
            console.log('Este navegador no soporta notificaciones');
            return;
        }

        // Si ya están concedidos, no hacer nada
        if (Notification.permission === 'granted') {
            console.log('✅ Permisos de notificación ya concedidos');
            return;
        }

        // Si están denegados, no molestar al usuario
        if (Notification.permission === 'denied') {
            console.log('❌ Permisos de notificación denegados por el usuario');
            return;
        }

        // Si están en "default" (no se han pedido), solicitarlos
        if (Notification.permission === 'default') {
            try {
                const permission = await Notification.requestPermission();
                if (permission === 'granted') {
                    toast.success('¡Notificaciones activadas! Recibirás alertas importantes.', {
                        position: "bottom-right",
                        autoClose: 5000,
                        theme: "colored"
                    });
                    console.log('✅ Permisos de notificación concedidos');
                } else {
                    console.log('⚠️ Usuario rechazó los permisos de notificación');
                }
            } catch (error) {
                console.error('Error al solicitar permisos:', error);
            }
        }
    };

    const generarTokenFirebase = async () => {


        const tokenFirebase = await getToken(messaging, {
            //serviceWorkerRegistration: registration,
            vapidKey: "BDgxI0yryiAvMlu9vmMDZibB-bmaSt5pj1Vrun_IsGWmzS3h5ubI69nRxId9HteusWK3d1cA1_Y1tFMdV4UjUkE",
        });


        verificarSesion(tokenFirebase);
    }

    /**
     * Obtiene las 10 notificaciones mas recientes del usuario
     */
    const obtenerNotificaciones = async (_iFirstNotification, _LastNotf, _LastNotfLiberados) => {

        //Si _iFirstNotification = 1 El lastNotf No importa porque no se usa en el query.- Solo se trae 15 notificaciones.- Se usa al ejecutar por primera vez
        //Si _iFirstNotification = 0 se trae todas las notificaciones hasta el lastNotf mas 15 nuevas .- Esta funciona para el scroll
        //Si _iFirstNotification = 2 se trae todas las notificaciones hasta lastNotf.- Se usa cuando se actualiza la pagina
        var jDataSend = {};
        jDataSend.idCatNotificacion = -1;
        jDataSend.lastNotification = _LastNotf;
        jDataSend.lastNotificationLiberados = _LastNotfLiberados;
        jDataSend.iFirstNotification = _iFirstNotification;

        console.log("jDataSend: ", jDataSend);

        const response = await fetch("/api/account/obtenerNotificacionesFiltradas/",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            }).catch(() => {

                //setMensajeError('Hubo un problema con la peticion Fetch:' + error);
                //setShowMensajeError(true);
                //console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {

            //console.log("============ OBTENER NOTIFICACIONES MAIN LAYOUT ============");
            const data = await response.json();

            if (data.iResponseType == 1) {

                var detalles = JSON.parse(data.detalles);

                var nNotfcArrayLiberados = [];
                if (_iFirstNotification == 0) {
                    nNotfcArrayLiberados = notificacionesLiberados;
                }

                detalles.table2.map((ntfLiberados) => {
                    nNotfcArrayLiberados.push(ntfLiberados);
                })

                setNotificacionesLiberados(nNotfcArrayLiberados);
                setLastNotfLiberados(detalles.table3[0].minimo);


                var nNotfcArray = [];
                if (_iFirstNotification == 0) {
                    nNotfcArray = notificaciones;
                }

                detalles.table4.map((ntf) => {
                    nNotfcArray.push(ntf);
                })

                setNotificaciones(nNotfcArray);
                setLastNotf(detalles.table5[0].minimo);

            } else {
                console.log("Error: ", data.vMessage);
            }

        }
        else {
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    }

    /**
     * Verifica si el usuario tiene aunque sea una notificacion sin leer 
     */
    const hayNotificacionesNoLeidas = async () => {

        const response = await fetch("/api/account/HayNotificacionesNoLeidas/",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }

            }).catch(() => {

                //console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {

            const data = await response.json();

            if (data.iResponseType == 1) {

                var detalles = JSON.parse(data.detalles);

                setIsAllRead(detalles.table2[0].TotalRegistros);
                setIsAllReadLiberados(detalles.table3[0].TotalRegistros);

            } else {

                console.log("Error: ", data.vMessage);

            }

        }
        else {
            console.log(response.status + ' ' + response.statusText);
            // console.log(response);
        }
    }

    useEffect(() => {
        // Solicitar permisos de notificación si no están concedidos
        solicitarPermisosNotificacion();

        generarTokenFirebase();

        setTimeout(() => {
            if (hash) {
                const id = hash.replace('#', '');
                const element = document.getElementById(id);
                if (element) {
                    element.scrollIntoView({ block: 'start', behavior: 'smooth' });
                }
            }
        }, 0);

        obtenerNotificaciones(1, lastNotf, lastNotfLiberados);
        hayNotificacionesNoLeidas();

        onMessage(messaging, (payload) => {
            console.log('📩 [MainLayout] onMessage recibido');
            console.log('payload: ', payload);
            console.log('payload.data: ', payload.data);
            console.log('document.hidden:', document.hidden);
            console.log('document.hasFocus():', document.hasFocus());

            obtenerNotificaciones(2, lastNotf, lastNotfLiberados);
            hayNotificacionesNoLeidas();

            // Sincronización en tiempo real de tickets de soporte
            let ticketId = payload?.data?.idTicket || payload?.data?.IdTicket;
            let messageText = payload?.data?.vTextoMensaje || payload?.data?.message || '';

            if (!ticketId && payload?.data?.vNotificacion) {
                try {
                    const parsed = JSON.parse(payload.data.vNotificacion);
                    ticketId = parsed?.idTicket || parsed?.IdTicket;
                    messageText = parsed?.vTextoMensaje || parsed?.message || messageText;
                } catch (e) {
                    console.warn('Error al parsear vNotificacion JSON:', e);
                }
            }

            if (ticketId) {
                window.dispatchEvent(new CustomEvent('akasia:support:ticket_activity', {
                    detail: {
                        idTicket: Number(ticketId),
                        vTextoMensaje: messageText,
                        dUltimaActividad: payload?.data?.dUltimaActividad || new Date().toISOString()
                    }
                }));
            }

            // Procesar el cuerpo de la notificación
            const notificationBody = payload.data.vNotificacion
                .replace(/<br\s*\/?>/gi, ' ')  // Reemplazar <br> con espacio
                .replace(/<[^>]+>/g, ' ')       // Reemplazar otras etiquetas con espacio
                .replace(/\s+/g, ' ')           // Normalizar espacios múltiples
                .trim();                        // Quitar espacios al inicio/fin

            // Si la ventana está OCULTA (en segundo plano), mostrar notificación nativa de Windows
            if (document.hidden) {
                console.log('🔔 Ventana en segundo plano - Mostrando notificación nativa');
                // Verificar permisos de notificación
                if (Notification.permission === 'granted') {
                    const notification = new Notification('Notificación Akasia AdminPanel', {
                        body: notificationBody,
                        icon: '/img/akasia-logo.png',
                        requireInteraction: true,
                        tag: 'akasia-' + Date.now()  // Tag único para cada notificación
                    });

                    // Al hacer clic en la notificación, enfocar la ventana
                    notification.onclick = function () {
                        window.focus();
                        notification.close();
                    };

                    console.log('✅ Notificación nativa creada:', notification);
                } else {
                    console.log('⚠️ Permisos de notificación:', Notification.permission);
                }
            } else {
                // Si la ventana está VISIBLE (en primer plano), mostrar toast
                toast.info(<span dangerouslySetInnerHTML={{ __html: payload.data.vNotificacion }} />, {
                    position: "top-right",
                    autoClose: 8000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Flip,
                });
            }
        });



    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);

        // Token ya se genera en el primer useEffect - NO duplicar
        // generarTokenFirebase();

        obtenerNotificaciones(2, lastNotf, lastNotfLiberados);
        hayNotificacionesNoLeidas();

        onMessage(messaging, (payload) => {

            obtenerNotificaciones(2, lastNotf, lastNotfLiberados);
            hayNotificacionesNoLeidas();

            toast.info(<span dangerouslySetInnerHTML={{ __html: payload.data.vNotificacion }} />, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Flip,
            });

            console.log("payload: ", payload);
            console.log("payload.data: ", payload.data);
            console.log("notificaciones", notificaciones);
        });



    }, [pathname]);

    return (
        <div className={isFluid ? 'container-fluid' : 'container'}>
            {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
                <NavbarVertical />
            )}

            <div className={classNames('content', { 'pb-0': isKanban })}>
                <NavbarTop
                    notificaciones={notificaciones}
                    notificacionesLiberados={notificacionesLiberados}
                    setIdLead={setIdLead}
                    setShowModalSeguimientoLead={setShowModalSeguimientoLead}
                    isAllRead={isAllRead}
                    setIsAllRead={setIsAllRead}
                    isAllReadLiberados={isAllReadLiberados}
                    setIsAllReadLiberados={setIsAllReadLiberados}
                    hayNotificacionesNoLeidas={hayNotificacionesNoLeidas}
                    obtenerNotificaciones={obtenerNotificaciones}
                    lastNotf={lastNotf}
                    lastNotfLiberados={lastNotfLiberados}
                    setShowReleaseModal={setShowReleaseModal}
                />
                {/*------ Main Routes ------*/}
                <Outlet />
                {!isKanban && <Footer />}
                {
                    <ModalSeguimientoLead
                        showModal={showModalSeguimientoLead}
                        setShowModal={setShowModalSeguimientoLead}
                        idLead={idLead}
                        setIdLead={setIdLead}
                    />
                }
                {
                    console.log("MainLayout JSX: Render condition showReleaseModal =", showReleaseModal, "isDeudaOpen =", isDeudaOpen)
                }
                {
                    (showReleaseModal && !isDeudaOpen) && (
                        <ReleaseNotesModal 
                            show={showReleaseModal} 
                            setShow={(val) => { console.log("MainLayout JSX: Setting showReleaseModal to", val); setShowReleaseModal(val); }} 
                            onDismissForever={handleReleaseNotesDismissForever}
                        />
                    )
                }
            </div>


        </div>
    );
};

export default MainLayout;
